import React from "react";

type ContextType = {
  indicators: any,
  
}
export default React.createContext<ContextType>({
  indicators: null,
})